import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    data: [],
    page: {
        page: 1,
        size: 10,
        totalPage: 1,
        totalSize: 1,
    }
};

const productionSlice = createSlice({
    name: 'production',
    initialState,
    reducers: {
        funGetProduction(state, action){
            const { list, page, size, totalPage, totalSize } = action.payload;
            state.data = list.map(( production ) => {
                return{
                    ...production,
                }
            });
            state.page = { page, size, totalPage, totalSize };
        }
    },
});

export const productionActions = productionSlice.actions;
export default productionSlice.reducer;